<template>
  <div>
    <ClientOnly>
      <TopNavigation />
    </ClientOnly>
    <main>
      <slot />
    </main>
    <ClientOnly>
      <PageFooter />
    </ClientOnly>
  </div>
</template>

<script setup>
// Add error handling for potential rendering issues
onErrorCaptured((err) => {
  console.error('Layout error captured:', err)
  return false
})
</script>
